module.exports = __webpack_public_path__ + "img/icon_sport_type_27.e4414321.png";